export const ShopCartGoodsStatusEnum = {
  normal: 1
}
